import { ContaParaExtratoBancarioResponse } from "../typings";
import http from "infra/http";
import { ListarContasParaExtratoQuery } from "../typings/index";

import { useQuery } from "react-query";

function useListarContasParaExtrato(
  params: ListarContasParaExtratoQuery,
  forceEnabled?: boolean
) {
  const parseValuesParams = Object.values(params)
    .map((value) => `${value}`)
    .join("-");

  return useQuery(
    `/v1/extrato-bancario/contas-${parseValuesParams}`,
    async () => {
      const { data } = await http.get<{
        items: ContaParaExtratoBancarioResponse[];
      }>(`/v1/extrato-bancario/contas`, {
        params,
      });

      return data;
    },
    {
      enabled: !!params.operacao || forceEnabled,
    }
  );
}

export default useListarContasParaExtrato;
